module.exports = __webpack_public_path__ + "img/b9d1e267-bb35-4d5c-a196-fae49460749d.9470e9e0.webp";